module.exports = __webpack_public_path__ + "img/RS3618xs.2b083546.png";